import React, { useContext } from 'react';
import i18next from 'i18next';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import './styles.scss';
import SubpageWhite from '../../SubpageWhite';
import ExpandableTextTile from '../../../../AutostadtTabComponents/Tiles/ExpandableTextTile';
import HeadlineTextTextlinkTile from '../../../../AutostadtTabComponents/Tiles/HeadlineTextTextlinkTile';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';
import { Trans } from 'react-i18next';

export default function AdditionalServices() {
    const store = useContext(SspProviderContext);

    return (
        <SubpageWhite
            title={i18next.t('AdditionalServicesTitle')}
            imageSrc={'/additional_services.webp'}
            imageCredits={''} //todo if we ever get them
            subline={i18next.t('AdditionalServicesSubline')}
        >
            <section id='additional-services'>
                <ExpandableTextTile headline={i18next.t('AVISTitle')}>
                    <>
                        <p className='body large'>
                            <Trans
                                i18nKey={'AVISText'}
                                components={{
                                    strong: <strong />,
                                    br: <br />,
                                }}
                            />
                        </p>
                        <Textlink
                            type={'svg-right'}
                            color={'dark-blue'}
                            text={i18next.t('ReserveRentalCar')}
                            svg='#as-link-external'
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://eixnbeweb01.rent-at-avis.com/avisonline/de/ibe.nsf/ReservationStep1?OpenForm&MST=F89E36DAA835A533C1258860002F6009&CCONSENT=',
                                });
                            }}
                        />
                        <Textlink
                            type={'svg-right'}
                            color={'dark-blue'}
                            text={i18next.t('ChangeReservation')}
                            svg='#as-link-external'
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://eixnbeweb01.rent-at-avis.com/avisonline/de/IBE.nsf/modifycancel?OpenForm&MST=F89E36DAA835A533C1258860002F6009&CCONSENT=',
                                });
                            }}
                        />
                    </>
                </ExpandableTextTile>

                <HeadlineTextTextlinkTile
                    headline={i18next.t('LuggageServiceHeadline')}
                    subline={i18next.t('LuggageServiceSubline')}
                    className='grey'
                    textlink1={{
                        text: i18next.t('PhoneNumber'),
                        svg: '#as-phone',
                        onClick: () => {
                            const numberWithoutSpaces =
                                i18next.t('PhoneNumber').replace(/\s+/g, '');
                            window.location.href = `tel:${numberWithoutSpaces}`;
                        },
                    }}
                    textlink2={{
                        text: i18next.t('ContactEmailAddress'),
                        svg: '#as-email',
                        onClick: () => {
                            const email = i18next.t('ContactEmailAddress');
                            window.location.href = `mailto:${email}`;
                        },
                    }}
                />
                <HeadlineTextTextlinkTile
                    headline={i18next.t('OvernightSpecialHeadline')}
                    subline={i18next.t('OvernightSpecialSubline')}
                    textlink1={{
                        text: i18next.t('OvernightSpecialTrain'),
                        svg: '#as-link-external',
                        onClick: () => {
                            setOverlay(store, {
                                enum: OverlayEnum.ExternalContent,
                                media: 'https://loki.aovotouristik.de/autostadt/app.html?product=7951',
                            });
                        },
                    }}
                    textlink2={{
                        text: i18next.t('OvernightSpecialNoTrain'),
                        svg: '#as-link-external',
                        onClick: () => {
                            setOverlay(store, {
                                enum: OverlayEnum.ExternalContent,
                                media: 'https://loki.aovotouristik.de/autostadt/app.html?product=7950',
                            });
                        },
                    }}
                />
            </section>
        </SubpageWhite>
    );
}
